// client/src/services/cardService.js
import { apiFetch } from '../../api/api';
import { SERVER_URL } from '../../constants/server-type';

const BASE = `/cards`;

// Local helper in case caller doesn't pass orgIdOverride
const getActiveOrgId = () => {
  if (typeof window === 'undefined') return '';
  return (
    localStorage.getItem('activeOrgId') ||
    localStorage.getItem('activeOrg') ||
    ''
  );
};

export const getAllCards = () =>
  apiFetch(`${BASE}/getAll`, { method: 'GET' });

export const getCardById = (id) =>
  apiFetch(`${BASE}/getById/${id}`, { method: 'GET' });

export const getFiltered = (filters = {}, orgIdOverride) =>
  apiFetch(`${BASE}/getFiltered`, {
    method: 'POST',
    body: filters,
    orgIdOverride: orgIdOverride ?? getActiveOrgId(),
  });

export const createCard = (payload, orgIdOverride) =>
  apiFetch(`${BASE}/create`, {
    method: 'POST',
    body: payload,
    orgIdOverride: orgIdOverride ?? getActiveOrgId(),
  });

export const updateCard = (id, payload, orgIdOverride) =>
  apiFetch(`${BASE}/update/${id}`, {
    method: 'PUT',
    body: payload,
    orgIdOverride: orgIdOverride ?? getActiveOrgId(),
  });

export const deleteCard = (id, orgIdOverride) =>
  apiFetch(`${BASE}/deletedoc/${id}`, {
    method: 'DELETE',
    orgIdOverride: orgIdOverride ?? getActiveOrgId(),
  });
